import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_QUALITY_CONTROL_API } from "./apiRoutes";

const getQualityControl = async (): Promise<any> => {
  return await axiosAuth.get(DASHBOARD_ADMIN_QUALITY_CONTROL_API);
};

const useGetQualityControl = (queryParams?: Omit<UseQueryOptions, "queryKey">): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-quality-control"],
    queryFn: getQualityControl,
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityControl;
